export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-extrabold text-foreground-950 text-center mb-3">
          移动端入口
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 max-w-lg mx-auto">
          随时随地，吃瓜不停
        </p>
        <div className="max-w-3xl mx-auto">
          <div className="bg-gradient-to-br from-primary-500 via-primary-600 to-accent-500 rounded-3xl p-8 md:p-12 text-center overflow-hidden relative">
            <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/4 blur-2xl"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/10 rounded-full translate-y-1/2 -translate-x-1/4 blur-2xl"></div>
            <div className="relative">
              <div className="w-16 h-16 mx-auto mb-5 rounded-2xl bg-white/20 flex items-center justify-center">
                <i className="ri-smartphone-line text-background-50 text-2xl"></i>
              </div>
              <h3 className="text-xl md:text-2xl font-heading font-extrabold text-background-50 mb-3">
                51吃瓜爆料网 · 移动端
              </h3>
              <p className="text-sm text-background-50/90 leading-relaxed max-w-md mx-auto mb-7">
                轻量版吃瓜短视频体验，流畅播放不卡顿。支持台北娜娜、玩偶姐姐、莫里秀等热门内容离线缓存，随时随地畅享吃瓜娱乐现场。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                <a
                  href="#"
                  className="w-full sm:w-auto px-7 py-3 bg-background-50 text-primary-600 font-semibold rounded-full hover:bg-background-100 transition-all text-sm whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-apple-line mr-2"></i>iOS 下载
                </a>
                <a
                  href="#"
                  className="w-full sm:w-auto px-7 py-3 bg-white/20 text-background-50 font-semibold rounded-full hover:bg-white/30 transition-all text-sm border border-white/30 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-android-line mr-2"></i>Android 下载
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}